import { useEffect, useState } from "react";
import "../css/RosterBox.css";

const RosterBox = ({ teamName, sport = "soccer", favoritePlayers=[], onFavoriteChange }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const fileName =
      sport === "football" ? "rosterFootball.json" : "rosterSoccer.json";

    // fetch(`${process.env.REACT_APP_API_URL}/api/
    const url = process.env.PUBLIC_URL + "/static/" + fileName;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const teamList = data[teamName] || [];
        setList(teamList);
      })
      .catch((err) => {
        console.log("roster error:", err);
        setList([]);
      });
  }, [teamName, sport]);

  const toggleFavorite = (playerKey) => {
    let updatedFavorites;
    if (favoritePlayers.includes(playerKey)) {
      updatedFavorites = favoritePlayers.filter(key => key !== playerKey);
    } 
    else {
      updatedFavorites = [...favoritePlayers, playerKey];
    }
    onFavoriteChange(updatedFavorites);
};

  return (
    <div className="roster-box">
      <div className="roster-header">
        <span style={{ paddingLeft: '25px' }}>#</span>
        <span>Player</span>
        <span className="pos-col">Position</span>
      </div>

      <div className="roster-list">
        {list.length === 0 ? (
          <p className="roster-empty">No roster available.</p>
        ) : (
          list.map((player, index) => {
            const playerKey = `${teamName}-${player.number}-${player.name}`;
            const isFavorite = favoritePlayers.includes(playerKey) || false;

            return (
              <div key={index} className="player-row">
                <span className="number-col favorite-number-col">
                  <button
                    type="button"
                    className={`player-star-btn ${isFavorite ? "active" : ""}`}
                    onClick={() => toggleFavorite(playerKey)}
                    aria-label="Toggle favorite player"
                  >
                    {isFavorite ? "★" : "☆"}
                  </button>
                  <span>{player.number}</span>
                </span>

                <span className="player-name">{player.name}</span>
                <span className="pos-col">{player.position}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default RosterBox;